import { useEffect, useState } from "react";
import Linkedin from "../../Atomos/Icons/ViewMode/Linkedin";
import Facebook from "../../Atomos/Icons/ViewMode/Facebook";
import XCircled from "../../Atomos/Icons/XCircled";
import Instagram from "../../Atomos/Icons/ViewMode/Instagram";
import WeChat from "../../Atomos/Icons/ViewMode/WeChat";
import Whatsapp from "../../Atomos/Icons/ViewMode/Whatsapp";
import { PersonSocialProps } from "../../../interfaces";
import ProfilePhoto from "../../Atomos/ProfilePhoto";
import { resolveProfilePictureDisplayUrl } from "../../../utils/profilePictureUrl";
import { PROFILE_PHOTO_UPDATED_EVENT } from "../../../utils/notifyProfilePhotoUpdated";

export interface IPersonCard extends PersonSocialProps {
  photo: string;
  id: string;
  name: string;
  lastName: string;
  title?: string;
  listTitle?: string;
  city?: string;
  country?: string;
  _ts?: number;
}

interface ISocialMedia {
  icon: JSX.Element;
  type: "linkedIn" | "x" | "facebook" | "instagram" | "whatsapp" | "weChat";
}
const socialMedia: ISocialMedia[] = [
  { icon: <Linkedin />, type: "linkedIn" },
  { icon: <XCircled />, type: "x" },
  { icon: <Facebook />, type: "facebook" },
  { icon: <Instagram />, type: "instagram" },
  { icon: <Whatsapp />, type: "whatsapp" },
  { icon: <WeChat />, type: "weChat" },
];
const ProfileContactFrame: React.FC<IPersonCard> = ({
  id,
  name,
  lastName,
  title,
  listTitle,
  city,
  country,
  socialNetworks,
  photo,
  _ts,
}) => {
  const [photoRenderKey, setPhotoRenderKey] = useState(0);

  useEffect(() => {
    const onProfilePhotoUpdated = (event: Event) => {
      const { personId } = (
        event as CustomEvent<{ personId: string; cacheBust: number }>
      ).detail;
      if (personId && personId === id) {
        setPhotoRenderKey((k) => k + 1);
      }
    };

    document.addEventListener(PROFILE_PHOTO_UPDATED_EVENT, onProfilePhotoUpdated);
    return () => {
      document.removeEventListener(
        PROFILE_PHOTO_UPDATED_EVENT,
        onProfilePhotoUpdated,
      );
    };
  }, [id]);

  const photoSrc = resolveProfilePictureDisplayUrl(id, photo, {
    photoUpdatedAt: _ts,
  });

  return (
    <div className="flex h-[7.5rem] gap-6 text-gray-font">
      <div className="h-[3.5rem] w-[3.5rem] lg:h-[7.5rem] lg:w-[7.5rem] shrink-0 overflow-hidden rounded-full outline outline-gray-200">
        <ProfilePhoto
          src={photoSrc}
          imgKey={`${id}-${photoRenderKey}`}
        />
      </div>

      <div className="flex flex-col flex-1 min-w-0 text-start">
        <div className="text-primary text-lg lg:text-xl font-bold mb-1 truncate ">
          {[name, lastName].filter(Boolean).join(" ")}
        </div>

        <div className="flex flex-col flex-1 text-sm lg:text-base">
          <span className="truncate">{title ?? listTitle}</span>
          <span className="truncate">
            {[city, country].filter(Boolean).join(", ")}
          </span>
        </div>

        <div className="flex h-6 justify-between w-full">
          {socialMedia.map((item, i) => {
            const network = socialNetworks?.find((sn) => sn.name === item.type);
            const isDisabled = !network || !network.url;

            return (
              <button
                key={i}
                disabled={isDisabled}
                onClick={() => {
                  if (!isDisabled && network?.url) {
                    window.open(network.url, "_blank");
                  }
                }}
                className={`w-5 h-5 lg:w-6 lg:h-6 ${
                  isDisabled
                    ? "text-gray-200"
                    : "text-gray-font hover:text-primary"
                }`}
              >
                {item.icon}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProfileContactFrame;
